import { use } from 'react';

import { MapInteractionStateContext } from './MapInteractionContext';
import { INITIAL_MAP_INTERACTION_STATE, type MapInteractionState } from './mapInteractionState';

/**
 * Reads the map-interaction slice (selected feature + located highlight).
 *
 * Frozen empty fallback for use outside a <MapInteractionProvider> — UNIT TESTS
 * ONLY. Every production route that renders MapView mounts the provider (Find & Fix
 * layout route; SAVI network-overview); a new map route must do the same.
 */
export function useMapInteraction(): MapInteractionState {
    return use(MapInteractionStateContext) ?? INITIAL_MAP_INTERACTION_STATE;
}
